import { FC } from 'react';
import { useLayoutContext } from 'contexts/LayoutContext';
import PageLoader from 'components/PageLoader';
import { Alert } from '@mui/material';
const VehicleSelectionGate: FC<{ children: React.ReactElement }> = ({
  children,
}) => {
  const { selectedVehicleId, isVehicleSwitching, availableVehicles } =
    useLayoutContext();

  if (isVehicleSwitching) {
    return <PageLoader />;
  }

  if ((availableVehicles?.length ?? 0) === 0) {
    return children;
  }

  if (selectedVehicleId) {
    return children;
  }

  return <Alert severity="info">No vehicles found</Alert>;
};

export default VehicleSelectionGate;
